<template>
        <div style="  font-family: '思源黑体', sans-serif ;">
            <div class="playersList" >
              <row>
                <Col span="7">
                <Menu :theme="theme" :open-names="['1']" accordion @on-select="handleSelect" >
<!--                  <Submenu  :name="item.name" v-for="(item, index) in routers" :key='index'>   this.getPlaters();
                    <template slot="title">
                      <Icon type="ios-folder" />
                      {{item.title}}
                    </template>
                    <Submenu :name="item1.name"   v-for="(item1, index1) in item.children" :key='item1.id'>
                      <template slot="title"><Icon type="ios-bookmark" />{{item1.title}}</template>
                      <MenuItem :to="'/Page_WX_Set/' + item2.name "  :name="item2.name"   v-for="(item2, index1) in item1.children" :key='item2.id'>{{item2.title}}</MenuItem>
                    </Submenu>
                  </Submenu>-->
                  <Submenu name="1" >
                    <template #title>
                      <Icon type="md-alert" />
                      主线任务
                    </template>
                    <div  v-for="(item, index) in playersList1" :key='item.taskId' >
                      <MenuItem :name="item.taskId" >{{item.taskName}} </MenuItem>
                    </div>
<!--                    <MenuItem name="1-2">评论管理</MenuItem>
                    <MenuItem name="1-3">举报管理</MenuItem>-->
                  </Submenu>
                  <Submenu name="2">
                    <template #title>
                      <Icon type="ios-alert" />
                      指引任务
                    </template>
                    <div  v-for="(item, index) in playersList4" :key='item.taskId' >
                      <MenuItem :name="item.taskId" >{{item.taskName}} </MenuItem>
                    </div>
                  </Submenu>
                  <Submenu name="3">
                    <template #title>
                      <Icon type="ios-map-outline" />
                      宗门任务
                    </template>
                    <div  v-for="(item, index) in playersList3" :key='item.taskId' >
                      <MenuItem :name="item.taskId" >{{item.taskName}} ({{ item.statusMsg}})</MenuItem>
                    </div>
<!--                    <MenuGroup title="战斗">-->
<!--                      -->
<!--                    </MenuGroup>-->
                  </Submenu>
                  <Submenu name="4">
                    <template #title>
                      <Icon type="ios-ionic-outline" />
                      活动任务(日常)
                    </template>
                    <MenuGroup title="日常活动">
                      <div  v-for="(item, index) in playersList2" :key='item.taskId' >
                        <MenuItem :name="item.taskId" >{{item.taskName}} ({{ item.statusMsg}})</MenuItem>
                      </div>
                    </MenuGroup>
                  </Submenu>
                  <Submenu name="6">
                    <template #title>
                      <Icon type="ios-flash" />
                      突发任务
                    </template>
<!--                    <MenuGroup title="单人">
                      <MenuItem name="3-1">突发任务1</MenuItem>
                      <MenuItem name="3-2">突发任务2</MenuItem>
                      <MenuItem name="3-3">突发任务3</MenuItem>
                    </MenuGroup>
                    <MenuGroup title="组队">
                      <MenuItem name="3-4">突发任务4-</MenuItem>
                      <MenuItem name="3-5">突发任务5-</MenuItem>
                    </MenuGroup>-->
                  </Submenu>
                </Menu>
                <Menu :theme="theme2" :open-names="['1']" accordion @on-select="handleSelect2" >
                    <!--                  <Submenu  :name="item.name" v-for="(item, index) in routers" :key='index'>
                                        <template slot="title">
                                          <Icon type="ios-folder" />
                                          {{item.title}}
                                        </template>
                                        <Submenu :name="item1.name"   v-for="(item1, index1) in item.children" :key='item1.id'>
                                          <template slot="title"><Icon type="ios-bookmark" />{{item1.title}}</template>
                                          <MenuItem :to="'/Page_WX_Set/' + item2.name "  :name="item2.name"   v-for="(item2, index1) in item1.children" :key='item2.id'>{{item2.title}}</MenuItem>
                                        </Submenu>
                                      </Submenu>-->
                  <Submenu name="1">
                    <template #title>
                      <Icon type="md-clipboard" />
                      悬赏任务
                    </template>
                    <MenuItem ><Button style="color: #F43e06" @click="selectTaskCate(1)">发布悬赏</Button> <Badge text="hot" /></MenuItem>
                    <div  v-for="(item, index) in myJbOrTaskList" :key='item.orTaskId' >
                      <MenuItem :name="item.orTaskId" >{{item.name}}</MenuItem>
                    </div>
                  </Submenu>
                  </Menu>
              </Col>
                <Col span="16" v-if="taskCategory === 0" style="font-family: '思源黑体', sans-serif ;">
                  <p style="text-align: center;font-weight: bold;font-size: 20px;margin-bottom: 20px"> {{taskObject.taskName}}</p>
                  <p style="font-size: 18px;text-indent: 1em;height: 300px;font-family: '思源黑体', sans-serif ;white-space:pre-wrap" v-html="taskObject.taskDesci"> {{taskObject.taskDesci}}</p>
                  <p style="font-size: 16px" v-if="taskObjectEject && taskObject.minLv !== null"> 等级限制: {{taskObject.minLv}} - {{taskObject.maxLv}} </p>
                  <p style="margin: 10px 0px;float: right">
                    <span v-if="taskObjectEject"  style="color: darkred;font-size: 16px"><Icon type="ios-refresh-circle-outline" size="30" @click="refreshTask()" /></span>
                  </p>
                  <p >
                    <span v-if="taskObjectEject && taskObject.needRule !== null"  style="color: darkred;font-size: 16px">任务要求:</span>
                    <div v-for="(dtl, index) in taskObject.needRule" :key='dtl.taskId'>
                      <span v-if="dtl.dtlType === 'map'" style="color: #2f90b9;font-size: 16px"><Icon type="ios-navigate-outline" />探索  {{dtl.dtlNeedName}}</span>
                      <span v-if="dtl.dtlType === 'mat'" style="color: #801DAE;font-size: 16px"><Icon type="ios-leaf-outline" />收集   {{dtl.dtlNeedName}} </span>
                      <span v-if="dtl.dtlType === 'monster'" style="color: #F43e06;font-size: 16px"><Icon type="ios-bonfire-outline" />消灭   {{dtl.dtlNeedName}}</span>
                      <span v-if="dtl.dtlType === 'boss'" style="color: #F43e06;font-size: 16px"><Icon type="ios-bug-outline" />讨伐  {{dtl.dtlNeedName}}</span>
                      <span v-if="dtl.dtlType === 'note'" style="color: #801DAE;font-size: 16px"><Icon type="ios-brush-outline" />完成  {{dtl.dtlNeedName}}</span>
                       {{dtl.dtlSubNum || 0}}/{{dtl.dtlNeedNum}}
                      <Icon v-if="taskObject.status === 1 && dtl.dtlType === 'mat' && dtl.dtlSubNum < dtl.dtlNeedNum" @click="submitTask(dtl.dtlNeedId)" type="md-add-circle" />
                      <div class="pasEject" v-if="subMatEject" >
                        <Select v-model="matPackId" style="width:200px;margin: 10px 0">
                          <Option  v-for="item in materialSmallList" :value="item.packItemId" :key="item.packItemId">{{ item.itemName }} * {{item.itemNum}}</Option>
                        </Select>
                        <Input  v-model="subTaskNum" type="Number" placeholder="请输入提交数量" />
                        <Button   size="small"   style="background-color:#2f90b9 ;color: #f7f4ed;font-family: 'Ma Shan Zheng', cursive" @click="submitMatTask(dtl.dtlId)">
                          提交材料
                        </Button>
                      </div>
                    </div>

                  </p>
                  <p >
                    <span  v-if="taskObjectEject && taskObject.rewardRule !== null"  style="color: darkred;font-size: 16px">奖励如下: </span><br>
<!-- 判断是否为指定                 v-if="taskObject.appoint==1"   -->
                    <RadioGroup v-model="rewardId" v-if="taskObject.appoint==1" vertical>
                      <Radio v-for="(dtl, index) in taskObject.rewardRule" :key='dtl.itemId' :label="dtl.itemId" style="color: #F43e06;font-size: 16px" >
                        <span ><Icon type="ios-navigate-outline" />{{dtl.typeDec}}  {{dtl.itemName}}</span> * {{dtl.dropNum}}
                      </Radio>
                    </RadioGroup>
                    <div v-for="(dtl, index) in taskObject.rewardRule" v-if="taskObject.appoint==null":key='dtl.itemId'>
                      <span style="color: #2f90b9;font-size: 16px"><Icon type="ios-navigate-outline" />{{dtl.typeDec}}  {{dtl.itemName}}</span>
                      * {{dtl.dropNum}}
                    </div>
                    <p style="font-size: 16px" v-if="taskObjectEject && taskObject.sectContr !== null"> 宗门贡献: {{taskObject.sectContr}} </p>
                  </p>
                  <p style="margin: 10px 0px;float: right">
                    <Button  v-if="taskObject.status === 0"    style="background-color:#2f90b9 ;color: #f7f4ed;" @click="receiveTask()">
                      接取任务
                    </Button>
                    <Button v-if="taskObject.status === 2" type="error" size="small" @click="claimRewards()">
                      领取奖励
                    </Button>
                  </p>

                  <!--        <div class="mapLoots">-->
                  <!--            <p v-for="(mapLoots, index) in mapLootsList" :key="index">-->
                  <!--                {{ mapLoots.mapName }}:-->
                  <!--                <template v-if="mapLoots.itemsVoList">-->
                  <!--                    <span v-for="(loot, idx) in mapLoots.itemsVoList" :key="idx">-->
                  <!--                        <template v-if="loot">-->
                  <!--                            <span :style="{ color: distinguishColor(loot.color) }">-->
                  <!--                                {{ loot.itemName }}-->
                  <!--                            </span>-->
                  <!--                        </template>-->
                  <!--                    </span>-->
                  <!--                </template>-->
                  <!--            </p>-->
                  <!--        </div>-->
                  <br />
                </Col>
                <!--  悬赏任务详情       -->
                <Col span="16" v-if="taskCategory === 2" style="font-family: STKaiTi;" >
                  <p style="text-align: center;font-weight: bold;font-size: 20px;margin-bottom: 20px"> {{taskOrObject.name}}</p>
                  <p style="margin: 10px 0px;float: right" v-if="taskOrObject.busStatus === 3 || taskOrObject.busStatus === 4">
                    <img  src="@/assets/success.png" alt="等待图片加载ing" style="width: 170px; height: 150px" />
                  </p>
                  <p style="font-size: 18px;text-indent: 1em;height: 180px;font-family: '思源黑体', sans-serif ;white-space:pre-wrap" v-html="taskOrObject.taskDesc"> {{taskOrObject.taskDesc}}</p>
                  <br>
                  <p> <span style="color: #801DAE;font-size: 16px"><Icon type="ios-leaf-outline" />悬赏物品: {{taskOrObject.goodName}}  </span> </p>
                  <p> <span style="color: #801DAE;font-size: 16px"><Icon type="ios-leaf-outline" />悬赏数量: {{taskOrObject.goodNum}} </span></p>
                  <br>
                  <p style="font-size: 14px" ><span style="color: #F43e06;font-size: 16px"><Icon type="ios-bug-outline" /> 付出物品: {{taskOrObject.interchangeName}}</span> </p>
                  <p style="font-size: 14px" ><span style="color: #F43e06;font-size: 16px"><Icon type="ios-bug-outline" />  付出数量: {{taskOrObject.interchangeNum}}</span> </p>
                  <br>
                  <p style="font-size: 16px;color: #2f90b9;" > 境界限制: 凡人 - 碎虚镜 </p>
                  <p style="font-size: 16px;color: #2f90b9;" > 悬赏人: {{taskOrObject.sellerName}}  </p>
                  <p><span style="color:green;font-size: 16px"> 期限: {{taskOrObject.dayNum}} 天 </span> </p>
                  <p style="font-size: 16px;color:green;" > 押金: {{taskOrObject.price}} 灵石 </p>
                  <p style="font-size: 16px;color:green;" >揭榜时间: {{taskOrObject.buyTime}}</p>
                  <p style="margin: 10px 0px;float: right">
                    <Button v-if="taskOrObject.busStatus === 2" type="error" size="small" @click="claimRewards2()">
                      交付悬赏物品
                    </Button>
                  </p>

                  <!--        <div class="mapLoots">-->
                  <!--            <p v-for="(mapLoots, index) in mapLootsList" :key="index">-->
                  <!--                {{ mapLoots.mapName }}:-->
                  <!--                <template v-if="mapLoots.itemsVoList">-->
                  <!--                    <span v-for="(loot, idx) in mapLoots.itemsVoList" :key="idx">-->
                  <!--                        <template v-if="loot">-->
                  <!--                            <span :style="{ color: distinguishColor(loot.color) }">-->
                  <!--                                {{ loot.itemName }}-->
                  <!--                            </span>-->
                  <!--                        </template>-->
                  <!--                    </span>-->
                  <!--                </template>-->
                  <!--            </p>-->
                  <!--        </div>-->
                  <br />
                </Col>
                <Col span="16" v-if="taskCategory === 1" style="font-family: Arial,Helvetica,Sans-Serif;" >
                  <p style="float: right;padding-bottom: 10px">
<!--                    <Button style="color: #F43e06" @click="handleSubmit('formValidate')">发布悬赏</Button>-->
                    <Button style="color:#2f90b9 " @click="rewardList(1)" >悬赏列表</Button>
                  </p>
                  <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
                    <FormItem label="任务名" prop="name" style="width: 70%">
                      <Input v-model="formValidate.name" placeholder="请输入任务名"></Input>
                    </FormItem>
                    <FormItem label="任务描述" prop="desc">
                      <Input v-model="formValidate.desc" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入任务描述..."></Input>
                    </FormItem>

                    <FormItem label="悬赏物品" prop="rewardId">
                      <Select v-model="formValidate.rewardId" placeholder="选择悬赏物品">
                        <Option  v-for="item in materialExchangeList" :value="item.itemId" :key="item.itemId">{{ item.itemName }}  <span style="float:right;color:#ccc">『{{item.typeDec}}』</span> </Option>
                      </Select>
                    </FormItem>
                    <FormItem label="悬赏物品数量" prop="rewardNum">
                      <Input v-model="formValidate.rewardNum" type="number" placeholder="输入物品数量"></Input>
                    </FormItem>

                    <FormItem label="付出物品" prop="exchangeId">
                      <Select v-model="formValidate.exchangeId" placeholder="选择交换悬赏物品">
                        <Option  v-for="item in smallExchangeList" :value="item.packItemId" :key="item.packItemId">{{ item.itemName }} * {{item.itemNum}} <span style="float:right;color:#ccc">『{{item.typeDec}}』</span></Option>
                      </Select>
                    </FormItem>
                    <FormItem label="付出物品数量" prop="exchangeNum">
                      <Input v-model="formValidate.exchangeNum" placeholder="输入交换物品数量"></Input>
                    </FormItem>

                    <FormItem label="悬赏天数" prop="exchangeDay">
                      <Select v-model="formValidate.exchangeDay" placeholder="选择悬赏天数" default-label="今日">
                        <Option value="1" label="今日">
                          <span>今日</span>
                          <span style="float:right;color:#ccc">该时较短请注意</span>
                        </Option>
                        <Option value="2" label="两日">
                          <span>两日</span>
                          <span style="float:right;color:#ccc">两日时间</span>
                        </Option>
                        <Option value="3" label="三日">
                          <span>三日</span>
                          <span style="float:right;color:#ccc">三日时间足以</span>
                        </Option>
                      </Select>
                    </FormItem>
                    <FormItem>
<!--                      <Button type="primary" @click="handleSubmit('formValidate')">发布悬赏</Button>-->
                      <Button style="color: #F43e06" @click="handleSubmit('formValidate')">发布悬赏</Button>
                      <Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
                      <Poptip transfer style="float: right;padding-bottom: 10px"
                              trigger="hover"
                      >
                        <p>
                          <Tag  color="success"  size="medium" >悬赏规则</Tag>
                        </p>
                        <div slot="content" >
                          注意事项：
                          <p >
                            <Tag size="medium" color="default" title="(任务榜单-发布悬赏)">悬赏流程：</Tag>
                            <Tag checkable color="primary" title="(任务榜单-发布悬赏)">发布悬赏</Tag>
                            <Tag checkable color="success" title="(悬赏列表-揭榜)">揭榜</Tag>
                            <Tag checkable color="error" title="(任务详情-交付悬赏)">交付悬赏</Tag>
                            <Tag checkable color="warning" title="(悬赏列表-我的悬赏-领取悬赏)">领取悬赏</Tag>
                          </p>
                          <p >
                            <Tag size="medium">  a：每人每天仅可发布两个悬赏任务，每人最多可提交/接取3个悬赏</Tag>
                          </p>
                          <p >
                            <Tag size="medium">   b：只有限定物品/材料可以进行悬赏，</Tag>
                          </p>
                          <p >
                            <Tag size="medium">   c：提交悬赏需要交付 物品等级*35 :灵石作为押金，其中25%作为手续费。</Tag>
                          </p>
                          <p >
                            <Tag size="medium">   d：提交悬赏后，付出物品将从背包立即扣除。</Tag>
                          </p>
                          <p >
                            <Tag size="medium">   e：玩家发布的悬赏任务只能由一个玩家获取。</Tag>
                          </p>
                          <p >
                            <Tag size="medium">   f：悬赏发布/接取要求最低境界为xxx境界</Tag>
                          </p>
                          <p >
                            <Tag size="medium">   g：接取悬赏玩家需要提交同等灵石作为押金，其中25%作为手续费</Tag>
                          </p>
                          <p >
                            <Tag size="medium">   h：悬赏完成后手续费自动扣除，返还玩家扣除手续费后的押金以及悬赏物品。</Tag>
                          </p>
                          <p >
                            <Tag size="medium">    i：悬赏发布后不可修改，</Tag>
                          </p>
                          <p >
                            <Tag size="medium">   j：悬赏过期：若未被接取：扣除发布者所有押金。
                            若已被接取：扣除接收任务者所有押金，退还发布者扣除手续费后的押金</Tag>
                          </p>
                          <p>
                            <Tag  color="error">  悬赏列表-我的悬赏里面 手动领取退还物品。</Tag>
                          </p>
                        </div>
                      </Poptip>
                    </FormItem>
                  </Form>
                </Col>
                <Modal v-model="jiebangEject" title="揭榜确认" @on-ok="show4()">
                  <p>确定揭榜这个悬赏吗</p>
                </Modal>

                <Modal style="font-family: STKaiTi" width="1020" title="悬赏" v-model="tradingBankEject" :styles="{ top: '100px' }">
                  <Tabs  style="background-color: #ffffff;color: black">
                    <TabPane label="可揭榜悬赏">
                      <Input v-model="orTaskName" placeholder="请输入悬赏任务名称..." style="margin-left:20px;margin-bottom:10px;width: auto" clearable/>
                      <Button style="margin-left:20px;margin-bottom:10px;width: auto" type="primary" @click="rewardList(1)" >查询</Button>
                      <Table border :columns="columnsTuzing" :data="orTaskList">
                        <template #name="{ row }">
                          <strong>{{ row.name }}</strong>
                        </template>
                        <template #action="{ row, index }">
                                              <Button type="primary" size="small" style="margin-right: 5px"  v-if="row.busStatus === 1" @click="jiebang(row.orTaskId,index)">揭榜</Button>
                          <!--                    <Button type="success" size="small" v-if="row.isMet!=null && row.isMet"  @click="duanzao(index)">锻造</Button>-->
                        </template>
                      </Table>
                      <Page :total="total" :page-size="pageSize" @on-change="changepage"></Page>
                    </TabPane>
<!--                    <TabPane label="已揭榜悬赏">
                    </TabPane>-->
                    <TabPane label="我的悬赏" >
                      <Table border :columns="columnsTuzing" :data="myOrTaskList">
                        <template #name="{ row }">
                          <strong>{{ row.name }}</strong>
                        </template>
                        <template #action="{ row, index }">
                          <Button type="primary" size="small" style="margin-right: 5px"  v-if="row.busStatus === 3 " @click="claimRewards3(row.orTaskId)">领取兑换物品</Button>
                          <Button type="error" size="small" style="margin-right: 5px"  v-if="row.busStatus === 5" @click="claimRewards3(row.orTaskId)">退还材料</Button>
                          <!--                    <Button type="success" size="small" v-if="row.isMet!=null && row.isMet"  @click="duanzao(index)">锻造</Button>-->
                        </template>
                      </Table>
                    </TabPane>
                  </Tabs>
                </Modal>
              </Row>
<!--                <Poptip trigger="hover" v-for="(item, idx) in playersList" :key="idx" :title="item.name">-->
<!--                    <p style="white-space: nowrap; height: 24px">-->
<!--                        <span>{{ ++idx }}:{{ item.name }}:</span>-->
<!--                    </p>-->
<!--                    <div slot="content">-->
<!--                        <p>等级: {{ item.level }}</p>-->
<!--                        <p>攻击力: {{ item.attack }}</p>-->
<!--                        <p>法术攻击力: {{ item.magic }}</p>-->
<!--                        <p>防御力: {{ item.defense }}</p>-->
<!--                        <p>生命值 {{ item.health }}</p>-->
<!--                        <p>真气值: {{ item.mana }}</p>-->
<!--                        <p>当前经验值: {{ item.exp }}</p>-->
<!--                    </div>-->
<!--                </Poptip>-->

            </div>
            <div slot="extra"> <Button slot="extra" @click.prevent="getPlaters" size="small" type="info" ghost>
              刷新任务
            </Button></div>
        </div>
<!--  <SecondModal width="320" title="任务提交材料" v-model="subTaskEject" @on-ok="changeEstablish()" :styles="{ top: '100px' }">
    <div class="pasEject" style="height: 50px">
      任务所需材料
    </div>
    <div class="pasEject" >
      <Select style="width:200px;margin: 10px 0">
        <Option v-for="item in materialSmallList" :value="item.packItemId" :key="item.packItemId">{{ item.itemName }} * {{item.itemNum}}</Option>
      </Select>
    </div>
    <div class="pasEject" >
      <Input v-model="subTaskNum" placeholder="请输入提交数量" />
    </div>
  </SecondModal>-->

</template>

<script>
import {sleep} from "../utils";

export default {
    name: "playersList",
    data() {
        return {
            formValidate: {
              charaId: '',
              name: '',
              rewardId: '',
              rewardNum: '',
              interest: [],
              exchangeId: '',
              exchangeNum: '',
              exchangeDay:1,
              desc: ''
            },
            ruleValidate: {
                name: [
                  { required: true, message: '悬赏任务名称必填', trigger: 'blur' }
                ],
                rewardId: [
                  { required: true, message: '至少选择一个悬赏物品', trigger: 'change' }
                ],
                rewardNum: [
                  { required: true, message: '悬赏数量必填', trigger: 'change' },
                ],
                exchangeId: [
                  { required: true, message: '至少选择一个交换物品', trigger: 'change' }
                ],
                exchangeNum: [
                  { required: true, message: '交换数量必填', trigger: 'change' },
                ],
                desc: [
                  { required: true, message: '悬赏任务描述必填', trigger: 'blur' },
                  { type: 'string', min: 5, message: '最少输入五个字', trigger: 'blur' }
                ]
            },
            columnsTuzing: [
              {
                title: '悬赏',
                key: 'name',
                width: 160
              },
              {
                title: '悬赏描述',
                key: 'taskDesc',
                width: 200
              },
              {
                title: '悬赏人',
                key: 'sellerName',
                width: 100
              },
              {
                title: '悬赏物品',
                key: 'goodName',
                width: 150,
                render: (h, params) => {
                  let w= params.row.goodName;
                  if(params.row.goodNum!=null){
                    w=w+"*"+params.row.goodNum;
                  }
                  return h('span', w);
                }
              },
              {
                title: '交换物品',
                key: 'interchangeName',
                width: 150,
                render: (h, params) => {
                  let w= params.row.interchangeName;
                  if(params.row.interchangeNum!=null){
                    w=w+"*"+params.row.interchangeNum;
                  }
                  return h('span', w);
                }
              },
              {
                title: '赏金',
                key: 'price',
                width: 90
              },
              {
                title: '悬赏状态',
                key: 'busStatus',
                width: 100,
                render: (h, params) => {
                  switch (params.row.busStatus) {
                    case 1:
                      return h('span', '未接取');
                      break;
                    case 2:
                      return h('span', '悬赏中');
                      break;
                    case 3:
                      return h('span', '待领取');
                      break;
                    case 4:
                      return h('span', '悬赏完成');
                      break;
                    case 5:
                      return h('span', '已过期');
                      break;

                  }
                },
              },
              {
                title: '操作',
                slot: 'action',
                width: 100,
                align: 'center'
              }
            ],
            tradingBankEject:false,
            orTaskName: '',
            pageSize: 20,
            total: 0,
            orTaskList: [],
            myOrTaskList: [],
            myJbOrTaskList: [],
            playersList: [], // 在线玩家列表-> 任务榜单
            subTaskEject:false,
            subMatEject:false,
            subTaskNum:0,
            matPackId:"",
            materialList: [],
            materialExchangeList: [],
            materialSmallList: [],
            smallExchangeList: [],
            playersList1:  [],
            playersList2:  [],
            playersList3:  [],
            playersList4:  [],
            taskObjectEject:false,
            jiebangEject:false,
            jbTaskId:"", //揭榜确认
            jbIndex:0,//揭榜确认
            taskObject:{},//任务详情
            taskOrObject:{},//悬赏任务详情
            taskCategory:0,//任务类别 0详情 1悬赏界面 2.悬赏列表
            rewardId:0,
        };
    },
    created() {
        setInterval(() => {
            this.getPlaters();
        }, 1000000);
    },
    methods: {
        // 列表
        getPlaters() {
            this.myRewardList(1);
            this.myRewardList(2);
            this.subMatEject=false;
            //玩家材料列表
            this.materialList = this.$store.state.materialList;
            // 在线玩家列表
            this.$http.post("/gameTask/queryTaskList?charaId="+
              this.getCookie("charaId")
              ,{
                headers:{
                  'Authorization': this.getCookie("token")
                }
              }).then((res) => {
                this.playersList = res.data.data;
                this.playersList1 = [];
                this.playersList2 = [];
                this.playersList3 = [];
                this.playersList4= [];
                for (let i = 0; i < this.playersList.length; i++) {
                  if(this.playersList[i].status==null){
                    this.playersList[i].status=0;
                  }
                  if(this.playersList[i].status === 0 || this.playersList[i].status === null){
                    this.playersList[i].statusMsg="未接取";
                  }else if(this.playersList[i].status === 1){
                    this.playersList[i].statusMsg="进行中";
                  }else if(this.playersList[i].status === 2){
                    this.playersList[i].statusMsg="待领取";
                  }else{
                    this.playersList[i].statusMsg="";
                  }
                  if(this.playersList[i].taskType === 'mainTask' ){
                    this.playersList1.push(this.playersList[i]);
                  }else if(this.playersList[i].taskType === 'actTask' ){
                    this.playersList2.push(this.playersList[i]);
                  }else if(this.playersList[i].taskType === 'sectTask' ){
                    if(this.playersList[i].status !== 9){
                      this.playersList3.push(this.playersList[i]);
                    }
                  }else if(this.playersList[i].taskType === 'guideTask' ){
                    this.playersList4.push(this.playersList[i]);
                  }
                }
            });
        },
        handleSelect(name) {
          for (let i = 0; i < this.playersList.length; i++) {
            if (this.playersList[i].taskId == name) {
              this.taskObject = this.playersList[i];
              this.taskObjectEject = true;
              this.taskCategory = 0;
              break;
            }
          }
        },
        handleSelect2(name) {
          for (let i = 0; i < this.myJbOrTaskList.length; i++) {
            if (this.myJbOrTaskList[i].orTaskId == name) {
              this.taskOrObject = this.myJbOrTaskList[i];
              this.taskCategory = 2;
              break;
            }
          }
        },
        submitTask(dtlNeedId){
          this.subMatEject=true;
          this.materialSmallList=[];
          this.smallExchangeList=[];
          for (let i = 0; i < this.materialList.length; i++) {
            if(this.materialList[i].itemId == dtlNeedId ){
              this.materialSmallList.push(this.materialList[i]);
            }
            if(this.materialList[i].isExchange === 1){
              this.smallExchangeList.push(this.materialList[i]);
            }
          }
        },
        // 获取用户全部材料包裹
        refreshMaterialPackage() {
          this.$http
            .post(
              "/gameChara/getCharaMaterial/?charaId=" + this.getCookie("charaId")
            )
            .then((res) => {
              this.materialList = res.data.data;
            })
            .catch((err) => {
              this.$Notice.warning({title:"获取材料包裹失败,请联系管理员"});
            });
        },
        // 获取可悬赏全部材料包裹
        gainExchangeItemList() {
          this.$http
            .post(
              "/gameMarket/gainExchangeItemList/?charaId=" + this.getCookie("charaId")
            )
            .then((res) => {
              this.$Notice.success({title:res.data.msg});
              this.materialExchangeList = res.data.data;
              this.materialList = this.$store.state.materialList;
              this.smallExchangeList=[];
              for (let i = 0; i < this.materialList.length; i++) {
                if(this.materialList[i].isExchange === 1){
                  this.smallExchangeList.push(this.materialList[i]);
                }
              }
            })
            .catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        submitMatTask(dtlId){
          //客户
          //角色任务id
          this.$http.post("/gameTask/submitMatTask?charaId="+
            this.getCookie("charaId")+
            "&taskId=" + dtlId +
            "&packId=" + this.matPackId +
            "&packNum=" +  this.subTaskNum
          ).then((res) => {
            this.$Notice.success({title:res.data.msg});
            //刷新任务
            this.refreshTask();
            this.refreshMaterialPackage();
          }).catch((err) => {
            this.$Notice.warning({title:err.data.msg});
          });
        },
        selectTaskCate(value){
            this.taskCategory=value;
            //可悬赏物品
            this.gainExchangeItemList();
        },
        refreshTask(){
          this.$http.post("/gameTask/refreshTask?charaId="+
            this.getCookie("charaId")+
            "&taskId=" + this.taskObject.taskId
          ).then((res) => {
            //刷新任务
            this.subMatEject=false;
            this.taskObject=res.data.data;
            this.taskObjectEject = true;
            this.taskCategory = 0;
            if(this.taskObject.status === null){
              this.taskObject.status=0;
            }
            //玩家材料列表
            this.materialList = this.$store.state.materialList;
            this.$Notice.success({title:"已刷新"});
          }).catch((err) => {
            this.$Notice.warning({title:err.data.msg});
          });
        },
        jiebang(taskId,index){
          this.jiebangEject=true;
          this.jbTaskId=taskId;
          this.jbIndex=index;
        },
        show4(){
          this.$http.post("/gameTask/playersUnveiling?charaId="+
            this.getCookie("charaId")+
            "&orId=" + this.jbTaskId
          ).then((res) => {
            //刷新任务
            this.$Notice.success({title:res.data.msg});
            this.orTaskList.splice(this.jbIndex, 1);
            this.myRewardList(2);
          }).catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        claimRewards2(){
          this.$http.post("/gameTask/playersDeliveryBounty?charaId="+
            this.getCookie("charaId")+
            "&orId=" + this.taskOrObject.orTaskId
          ).then((res) => {
            //刷新任务
            this.taskOrObject.busStatus = 3;
            this.$Notice.success({title:res.data.msg});
          }).catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        claimRewards3(taskId){
          this.$http.post("/gameTask/playersRewardBounty?charaId="+
            this.getCookie("charaId")+
            "&orId=" + taskId
          ).then((res) => {
            //刷新任务
            this.$Notice.success({title:res.data.msg});
            this.myRewardList(1);
          }).catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        receiveTask(){
          this.$http.post("/gameTask/pickUpTask?charaId="+
            this.getCookie("charaId")+
            "&taskId=" + this.taskObject.taskId
          ).then((res) => {
              this.$Notice.success({title:res.data.msg});
              //刷新任务
              //this.taskObject=[];
              this.refreshTask();
              this.getPlaters();
          })
        },
        claimRewards(){
          if(this.taskObject.appoint==null){
            this.rewardId=0;
          }
          if(this.taskObject.appoint === 1 && this.rewardId==0){
            this.$Notice.warning({title:"必须指定奖励!"});
          }else{
            this.$http.post("/gameTask/claimRewards?charaId="+
              this.getCookie("charaId")+
              "&taskId=" + this.taskObject.taskId+
              "&rewardId=" + this.rewardId
            ).then((res) => {
              this.$Notice.success({title:res.data.msg});
              //刷新任务
              //this.taskObject=[];
              this.refreshTask();
            }).catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
          }
        },
      handleSubmit (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            //赋值角色Id
            this.formValidate.charaId=this.getCookie("charaId");
            //验证成功访问接口
            this.$http.post("gameTask/offerReward", this.formValidate).then((res) => {
              this.$Notice.success({title:res.data.msg});
             /* if (res.data.msg != "OK") {
                console.log("看起来是账号密码错误了");
                this.$Notice.warning({title:res.data.msg});
                return;
              }*/
              this.handleReset('formValidate');
              this.myRewardList(1);
            }).catch((err) => {
              this.$Notice.error({title:err.data.msg});
            });
            //this.$Notice.success('Success!');
          } else {
            this.$Notice.error({title:'Fail!'});
          }
        })
      },
      changepage(index) {
        this.rewardList(index);
      },
      rewardList(index){
        this.taskCategory=2;
        this.tradingBankEject=true;
        this.$http.post("gameTask/getOfferRewardList?page=" + index + "&pageSize=" + this.pageSize + '&name=' + this.orTaskName).then((res) => {
          this.orTaskList = res.data.rows;
          this.total = res.data.records
        }).catch((err) => {
          this.$Notice.info({title:'暂无悬赏任务可接取!'});
        });
      },
      myRewardList(type){
        this.$http.post("gameTask/getOfferRewardReceivedList?charaId="+
          this.getCookie("charaId")+
          "&type=" + type
          ).then((res) => {
            if(type === 1){
              this.myOrTaskList = res.data.data;
            }else{
              this.myJbOrTaskList = res.data.data;
            }
        }).catch((err) => {
          this.$Notice.info({title:'暂无!'});
        });
      },

      handleReset (name) {
        this.$refs[name].resetFields();
      }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 在线玩家列表 */
.playersList {
    max-height: 606px;
    min-height: 406px;
    overflow: auto;
}
.playersList /deep/ .ivu-poptip {
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/playersList.vue